import "./App.css";
import React from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./components/Header/Header";
import Home from "./components/Mid/Home/Home";
import AboutUs from "./components/Mid/AboutUs/AboutUs";
import Products from "./components/Mid/Products/Products";
import Contact from "./components/Mid/Contact/Contact";
import FindUs from "./components/FindUs/FindUs";
import ProductList from "./components/Mid/Products/ProductList";
import SingleProduct from "./components/Mid/Products/SingleProduct";
import "./General.css";
import Page404 from "./components/Page404";

function App() {
  return (
    <div className="container">
      <Header />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/AboutUs" element={<AboutUs />} />
        <Route exact path="/Products" element={<Products />} />
        <Route exact path="/Contact" element={<Contact />} />
        <Route exact path="/ProductList" element={<ProductList />} />
        <Route exact path="/product/:id" element={<SingleProduct />} />
        <Route exact path="/*" element={<Page404 />} />
      </Routes>
      <FindUs />
    </div>
  );
}

export default App;
